import { RuleActionType } from '@jupiterone/jupiter-types';
import { ArrayInput, JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { TextField } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import { EmailActionData, RuleActionData } from 'jupiter-web-alerts/src/types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    full: {
      display: 'block',
      marginBottom: theme.spacing(1),
    },
    container: {
      marginBottom: theme.spacing(3),
    },
  })
);

interface Props {
  onUpdate: (newValue: RuleActionData) => void;
  disabled?: boolean;
  initialActionData?: EmailActionData;
  templateData?: Record<string, string>;
}

const SendEmailRuleConfig = ({
  onUpdate,
  disabled,
  initialActionData,
  templateData,
}: Props) => {
  const classes = useStyles();
  const DEFAULT_BODY = templateData?.emailBody
    ? `Affected Items: <br><br>{{queries.query0.data|mapTemplate('emailBody')|join(' ')}}`
    : `Affected Items: <br><br>* {{queries.query0.data|mapProperty('displayName')|join('<br>* ')}}`;
  const [emailRecipients, setEmailRecipients] = useState<string[]>(
    initialActionData?.recipients || []
  );
  const [body, setBody] = useState<string>(
    initialActionData?.body || DEFAULT_BODY
  );

  useEffect(() => {
    const action: RuleActionData = {
      ...initialActionData,
      type: RuleActionType.SEND_EMAIL,
      recipients: emailRecipients,
      body: body,
    };
    if (!body) {
      delete action.body;
    }
    onUpdate(action);
  }, [body, emailRecipients]);

  const handleChangeBody = (e: any) => setBody(e.target.value);

  return (
    <div data-testid="SendEmailRuleConfig">
      <ArrayInput
        onUpdate={setEmailRecipients}
        inputLabel={'Recipient Email Addresses'}
        aria-label="Recipient Email Addresses"
        inputPlaceholder={'New Recipient'}
        disabled={disabled}
        initialValues={initialActionData?.recipients}
      />
      <TextField
        className={classes.full}
        fullWidth={true}
        onChange={handleChangeBody}
        name={'body'}
        value={body}
        label={'Email Body'}
        disabled={disabled}
      />
    </div>
  );
};

export default SendEmailRuleConfig;
